import type { ReactiveController, ReactiveControllerHost } from "lit";
import { v4 as uuidv4 } from "uuid";
import type { Toast, ToastLevel } from "../types/ui";

export class ToastController implements ReactiveController {
  private host: ReactiveControllerHost;
  toasts: Toast[] = [];

  constructor(host: ReactiveControllerHost) {
    this.host = host;
    host.addController(this);
  }

  hostDisconnected(): void {
    // clear timeouts
    for (const t of this.toasts) {
      if (t.timeoutId) {
        try {
          window.clearTimeout(t.timeoutId);
        } catch {}
      }
    }
    this.toasts = [];
  }

  push(level: ToastLevel, text: string, autoHideMs = 2000): void {
    const existingIdx = this.toasts.findIndex(
      (t) => t.text === text && t.level === level
    );
    if (existingIdx >= 0) {
      const next = [...this.toasts];
      const existing = { ...next[existingIdx] } as Toast;
      if (existing.timeoutId) {
        try {
          window.clearTimeout(existing.timeoutId);
        } catch {}
      }
      const timeoutId = window.setTimeout(
        () => this.dismiss(existing.id),
        autoHideMs
      );
      existing.count = (existing.count || 1) + 1;
      existing.timeoutId = timeoutId as unknown as number;
      next[existingIdx] = existing;
      this.toasts = next;
      this.host.requestUpdate();
      return;
    }

    const id = uuidv4();
    const timeoutId = window.setTimeout(() => this.dismiss(id), autoHideMs);
    this.toasts = [
      ...this.toasts,
      { id, level, text, count: 1, timeoutId: timeoutId as unknown as number },
    ];
    this.host.requestUpdate();
  }

  dismiss = (id: string): void => {
    const t = this.toasts.find((x) => x.id === id);
    if (t?.timeoutId) {
      try {
        window.clearTimeout(t.timeoutId);
      } catch {}
    }
    this.toasts = this.toasts.filter((x) => x.id !== id);
    this.host.requestUpdate();
  };
}
